import React from 'react';
import '@/assets/styles/store-tool.less';

export default () => {
  const deviceRatio = 1
  return (
    <div className="store-tool-wrapper">
      <div className="title">门店二维码生成工具</div>
      <canvas id="canvas" style={{ display: 'none' }} width={1050 * deviceRatio} height={1050 * deviceRatio}></canvas>
      <img id="J_image" className="qr-image" crossOrigin="anonymous" />
    </div>
  )
}